export const environment = {
  production: true,
  apiBaseUrl: 'https://cmsapi.buy2go.us',
  googlePlacesApiKey: 'AIzaSyDhrOZct--DaTCFVeJqwkKVevP6UVsfIvI',
  EXPIRATION_TIME: 15, // 15 minutes
};
